import 'reflect-metadata';
import 'bootstrap/dist/css/bootstrap.css';
import './style/main.css';
import Bootstrap from './Bootstrap';

const bootstrap = new Bootstrap();


if (module.hot) {
    module.hot.accept();

    let lastUpdateTime = 0;

    module.hot.addStatusHandler((status) => {
        // console.log(`🔥 HMR Status: ${status}`);

        if (status === 'idle') {
            const now = Date.now();

            if (now - lastUpdateTime < 500) {
                console.log('⏭️ Skipping duplicate idle event');
                return;
            }

            lastUpdateTime = now;


            console.log('🎯 Auto-reloading scene...');

            if (window.hmr?.reloadCurrentScene) {
                setTimeout(() => {
                    window.hmr.reloadCurrentScene().catch((err) => {
                        console.error('❌ Auto-reload failed:', err);
                    });
                }, 100);
            } else {
                // console.log('⚠️ HMR not ready');
            }
        }
    });

    console.log('✅ HMR auto-reload enabled');
}